import Const from './Const';
import { keyBy } from 'lodash';
import { getDataFollowKeyByDot } from '../../../../helpers/Common';

export { fetchListDataCheckup };

function getDataFollowTypeBank(isBanking) {
  return {
    data: isBanking
      ? Const.mapRateIndicatorId.BANKING
      : Const.mapRateIndicatorId.NON_BANKING,
    type: isBanking ? 'BANKING' : 'NON_BANKING',
  };
}

function fetchListDataCheckup(listDataCheckup, isBanking) {
  let newFaCheckupData = [];
  const { data, type } = getDataFollowTypeBank(isBanking);

  Object.keys(data).forEach((keyBank, index) => {
    const { key, icon } = data[keyBank];

    newFaCheckupData.push({
      [Const.idFaCheckup]: index,
      key,
      icon,
      rateComment: '',
      rateIndicatorName: '',
      rateValue: '',
      item: `financialAnalysis.columnOneTable.${type}.${keyBank}`,
      rateResult: '',
    });
  });

  const listColumnTable = getListColumnTable(listDataCheckup);

  formatDataCheckup(listDataCheckup, newFaCheckupData);

  const listLookupItems = getListLookupItems(listDataCheckup);

  const listFaCheckupByTicker = keyBy(newFaCheckupData, Const.idFaCheckup);
  const listTickerFACheckup = newFaCheckupData.map(item => {
    return getDataFollowKeyByDot(item, Const.idFaCheckup);
  });

  const yearReport = checkYearReport(listDataCheckup);

  return {
    listColumnTable,
    listFaCheckupByTicker,
    listTickerFACheckup,
    listLookupItems,
    yearReport,
  };
}

function getListColumnTable(data) {
  if (data) {
    let listColumnTable = {};
    const { checkupItem, comparingCheckupItems } = data;

    if (checkupItem && comparingCheckupItems) {
      const combineData = [checkupItem, ...comparingCheckupItems];

      const listTicker = combineData.map(item => item.ticker);
      listColumnTable['item'] = 'item';
      listTicker.forEach((ticker, index) => {
        if (index === 0) {
          listColumnTable['checkupItem'] = ticker;
        } else if (index === 1) {
          listColumnTable['comparingCheckupItemOne'] = ticker;
        } else if (index === 2) {
          listColumnTable['comparingCheckupItemTwo'] = ticker;
        }
      });

      return listColumnTable;
    }
  }
  return null;
}

function formatDataCheckup(data, newFaCheckupData) {
  if (data) {
    const { checkupItem, comparingCheckupItems } = data;
    if (checkupItem && comparingCheckupItems) {
      const combineData = [checkupItem, ...comparingCheckupItems];

      newFaCheckupData.forEach(item => {
        combineData.forEach(item2 => {
          const { checkupInfors, ticker } = item2;

          const { rateResult, rateComment } = getCheckupInfo(
            checkupInfors,
            item,
          );
          item[ticker] = rateResult;
          item[`rateComment_${ticker}`] = rateComment;
        });
        const { checkupInfors } = checkupItem;

        const { rateComment, rateValue, rateIndicatorName } = getCheckupInfo(
          checkupInfors,
          item,
        );

        item.rateComment = rateComment;
        item.rateValue = rateValue;
        item.rateIndicatorName = rateIndicatorName;
      });
    }
  }
}

function getCheckupInfo(checkupInfors, itemCheckupResult) {
  let result = {};
  checkupInfors.forEach(item => {
    if (itemCheckupResult.key === item.rateIndicatorId) {
      result = item;
    }
  });

  return result;
}

function getListLookupItems(data) {
  let result = [];
  let idLookupItem = 1;

  const { lookupItems } = data;

  if (lookupItems) {
    lookupItems.forEach(({ ticker, organCode, organShortName }) => {
      result.push({
        key: idLookupItem++,
        ticker,
        organCode,
        organShortName,
      });
    });
  }

  return result;
}

function checkYearReport(listDataCheckup) {
  const { checkupItem } = listDataCheckup;

  if (checkupItem) {
    const { yearReport, lengthReport } = checkupItem;

    return lengthReport === 5
      ? yearReport
      : 'Q' + lengthReport + ' ' + yearReport;
  }
  return null;
}
